import { html } from '../../util/html.ts';

export type SchemaOrgJson = string[];

export type JsonLDLocals = {
  schemaOrgJson: SchemaOrgJson & { asArray?: (...args: unknown[]) => unknown },
};

export function jsonLD(props: JsonLDLocals) {
  const { schemaOrgJson } = props;

  if (!schemaOrgJson.length) {
    return html`<!-- JSON+LD unavailable -->`;
  }

  if (schemaOrgJson.asArray) {
    return html`<!-- JSON+LD -->
    <script type="application/ld+json">[
      ${schemaOrgJson.join(',')}
    ]</script>`;
  }

  return html`<!-- JSON+LD -->
  ${schemaOrgJson.map(item => html`
    <script type="application/ld+json">
      ${item}
    </script>`).join('')}`;
}
